<footer class="sticky-footer bg-white">
    <div class="container my-auto">
        <div class="copyright text-center my-auto">
            <span *ngIf="systemVersion">
                QCloud {{ systemVersion.version }} Copyright &copy; Promedio {{ currentYear }}
            </span>
        </div>
    </div>
</footer>